import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import { IProps } from './interfaces';

class Dropdown extends React.Component<IProps> {
  public render() {
    const { disabled, input, meta, title, helper } = this.props;

    return (
      <FormControl
        fullWidth={true}
        margin="dense"
        error={meta.touched && meta.error}
      >
        <TextField
          id={`outlined-select-${input.name}`}
          select={true}
          label={title}
          value={input.value}
          disabled={disabled}
          onChange={this.handleChange}
          helperText={helper}
          margin="normal"
          variant="outlined"
          fullWidth={true}
          SelectProps={{
            renderValue: (selectedValue: any, ...rest) => {
              const option = this.getOptions().find(
                (option: any) => option.value === selectedValue,
              );

              return option ? option.name || option.label : 'Unknown';
            },
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 280,
                },
              },
            },
          }}
        >
          {this.getOptions().map((option: any) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {meta.touched && meta.error && (
          <FormHelperText>{meta.error}</FormHelperText>
        )}
      </FormControl>
    );
  }

  private readonly getOptions = () => {
    const { options } = this.props;

    if (typeof options === 'function') {
      return options(this.props);
    }
    if (Array.isArray(options)) {
      return options;
    }

    return [];
  };

  private readonly handleChange = (event: any) => {
    const { input } = this.props;

    input.onChange(event.target.value);
  };
}

export default Dropdown;
